import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import {
  DialogTitle,
  Grid,
  TextareaAutosize,
  TextField,
  Typography,
} from "@material-ui/core";
import Slide from "@material-ui/core/Slide";
import "./modal.css";
import { Autocomplete } from "@material-ui/lab";
import moment from "moment";
import CloseIcon from "@material-ui/icons/Close";
import IconButton from "@material-ui/core/IconButton";

// import DialogTitle from '@material-ui/core/DialogTitle';
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function AlertDialog({
  modalTitle,
  handleAlertClose,
  openAlert,
  onConfirmHandler,
  title = "",
  noButtonText,
  yesButtonText,
  setOpenAlert,
  tanker,
  tankerCapacity,
  setTankerCapacity,
  currentFuel,
  RequestedFuel,
  approvedFuel,
  Remarkvalue,
  setCurrentFuel,
  setRequestedFuel,
  setApprovedFuel,
  setRemarkValue,
  VehicleId,
  setVehicleId,
  Diesel,
  setDisel,
  createbtn,
  Type,
  fromdate,
  setFromDate,
  vehicleList,
  vehicleId,
  getVehicleId,
  setiSsuedFuelQuantity,
  issuedFuelQuantity,
  selectedRow,
  setDeviceId,
  issuedFuel,
  setIssuedFuel,
  tankerCapacityvalue,
  setTankerCapacityvalue,
  getDateFilter,
  fromdateForModal,
}) {
  console.log(selectedRow);

  return (
    <div>
      <Dialog
        //className='Dialogbox'

        open={openAlert}
        onClose={handleAlertClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Grid>
              {Type == "createRequeste"
                ? "Add Diesel Request"
                : Type == "Reject"
                ? "Rejected Fuel Diesel"
                : Type == "Approve"
                ? "Pending Request Diesel"
                : Type == "Issue"
                ? "Issue Request Diesel"
                : Type == "createIssue"
                ? "Create Direct Issue Request"
                : Type == "sync"
                ? "Manual Sync"
                : ""}
            </Grid>
            <Grid>
              <IconButton aria-label="close" onClick={handleAlertClose}>
                <CloseIcon />
              </IconButton>
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {Type == "createRequeste" || Type == "createIssue" ? (
              <Grid style={{ margin: "10px 0" }} className="createrequeste">
                <Grid item xs={12} container direction="row" spacing={3}>
                  <Grid item xs={6}>
                    <Typography variant="h6">
                      <span>Vehicle Number</span>
                    </Typography>
                    <Autocomplete
                      style={{ backgroundColor: "white" }}
                      //id="combo-box-demo"
                      id="header"
                      getOptionLabel={(option) => option.number}
                      className="user"
                      options={vehicleList || []}
                      //disableClearable
                      disablePortal={true}
                      filterSelectedOptions
                      getOptionSelected={(option, value) =>
                        option.number === value.number
                      }
                      onChange={(event, value) => {
                        getVehicleId(value, Type);
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          value={vehicleId}
                          margin="dense"
                          variant="outlined"
                          placeholder="Select Vehicle"
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="h6">
                    
                      <span>Request Date</span>
                    </Typography>
                    <TextField
                      id="datetime-local"
                      name="fromDateForModal"
                      type="date"
                      margin="dense"
                      value={fromdateForModal}
                      onChange={getDateFilter}
                      variant="outlined"
                      style={{ backgroundColor: "white" ,marginTop:"-1px" }}
                      className="w-100"
                    />
                  </Grid>
                </Grid>
                
                <Grid item xs={12} container direction="row" spacing={3}>
                  <Grid item xs={6}>
                    <Typography variant="h6">
                      <span>Fuel Quantity</span>
                    </Typography>
                    <TextField
                      value={
                        Type == "createRequeste"
                          ? RequestedFuel
                          : Type == "createIssue"
                          ? issuedFuel
                          : ""
                      }
                      type="number"
                      variant="outlined"
                      placeholder="Diesel Quantity"
                      //  onChange={(e) => setDisel(e.target.value)}
                      onChange={(e) => {
                        console.log(e.target.value);
                        setRequestedFuel(e.target.value);
                        if (Type == "createIssue") {
                          setIssuedFuel(e.target.value);
                        }
                      }}
                      margin="dense"
                    />
                  </Grid>

                  <Grid item xs={6} style={{ width: "222px" }}>
                    <Typography variant="h6">
                      <span>Tanker Capacity</span>
                    </Typography>
                    <TextField
                      id="datetime-local"
                      type="number"
                      margin="dense"
                      readOnly
                      placeholder="Tanker Capacity"
                      value={
                        vehicleId && vehicleId.length > 0
                          ? tankerCapacityvalue
                          : ""
                      }
                      // onChange={(e) => {
                      //  setTankerCapacityvalue(e.target.value);
                      // }}
                      variant="outlined"
                      style={{ backgroundColor: "white" }}
                      className="w-100"
                      InputProps={{
                        readOnly: true,
                      }}
                    />
                  </Grid>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="h6">
                    <p>Remark</p>
                  </Typography>

                  <TextareaAutosize
                    //maxRows={4}
                    rowsMin={5}
                    maxLength={50}
                    value={Remarkvalue}
                    onChange={(e) => setRemarkValue(e.target.value)}
                    style={{
                      marginTop: "-8px",
                      width: "100%",
                      height: "60px",
                    }}
                    aria-label="maximum height"
                    placeholder="Enter Your Remark"
                  />
                </Grid>
              </Grid>
            ) : (
              ""
            )}

            {(Type == "Approve" || Type == "Issue" || Type == "sync") && (
              <Grid style={{ margin: "10px 0" }} className="createrequeste">
                <Grid
                  item
                  xs={12}
                  container
                  direction="row"
                  alignItems="center"
                  spacing={2}
                >
                  <Grid item xs={4}>
                    <Typography variant="h6">
                      {" "}
                      <span>Vehicle Number</span>
                    </Typography>
                  </Grid>
                  <Grid item xs={7}>
                    <TextField
                      value={selectedRow.vehicle.number}
                      // style={{background:"rgb(167, 164, 164)"}}
                      variant="outlined"
                      placeholder="Vehicle Number"
                      onChange={(e) => setDeviceId(selectedRow.vehicle.id)}
                      margin="dense"
                      InputProps={{
                        readOnly: true,
                      }}
                    />
                  </Grid>
                </Grid>
                {(Type == "Approve" || Type == "Issue") && (
                  <Grid
                    item
                    xs={12}
                    container
                    direction="row"
                    alignItems="center"
                    spacing={2}
                  >
                    <Grid item xs={4}>
                      <Typography variant="h6">
                        <span>Tanker Capacity</span>
                      </Typography>
                    </Grid>
                    <Grid item xs={7}>
                      <TextField
                        value={selectedRow.vehicle.fuelTankCapacity}
                        variant="outlined"
                        placeholder="Tanker Capacity"
                        onChange={(e) => setTankerCapacity(e.target.value)}
                        margin="dense"
                        InputProps={{
                          readOnly: true,
                        }}
                      />
                    </Grid>
                  </Grid>
                )}

                {/* <Grid
                item
                xs={12}
                container
                direction="row"
                alignItems="center"
                spacing={2}
              >
                <Grid item xs={4}>
                  <span>Current Fuel</span>
                </Grid>
                <Grid item xs={7}>
                  <TextField
                    value={currentFuel}
                    variant="outlined"
                    placeholder="Current Fuel"
                    onChange={(e) => setCurrentFuel(e.target.value)}
                    margin="dense"
                  />
                </Grid>
              </Grid> */}

                {(Type == "Approve" || Type == "Issue") && (
                  <Grid
                    item
                    xs={12}
                    container
                    direction="row"
                    alignItems="center"
                    spacing={2}
                  >
                    <Grid item xs={4}>
                      <Typography variant="h6">
                        <span>Requested Fuel</span>
                      </Typography>
                    </Grid>
                    <Grid item xs={7}>
                      <TextField
                        value={selectedRow.requestedFuelQuantity}
                        variant="outlined"
                        placeholder="Requested Fuel"
                        // onChange={(e) => setRequestedFuel(e.target.value)}
                        onChange={(e) => console.log(e.target.value)}
                        margin="dense"
                      />
                    </Grid>
                  </Grid>
                )}

                {Type == "sync" && (
                  <Grid
                    item
                    xs={12}
                    container
                    direction="row"
                    alignItems="center"
                    spacing={2}
                  >
                    <Grid item xs={4}>
                      <Typography variant="h6">
                        <span>Issued Fuel</span>
                      </Typography>
                    </Grid>
                    <Grid item xs={7}>
                      <TextField
                        value={selectedRow.issuedFuelQuantity}
                        variant="outlined"
                        placeholder="Requested Fuel"
                        readOnly
                        // onChange={(e) => setRequestedFuel(e.target.value)}
                        onChange={(e) => console.log(e.target.value)}
                        margin="dense"
                      />
                    </Grid>
                  </Grid>
                )}
                <Grid
                  item
                  xs={12}
                  container
                  direction="row"
                  alignItems="center"
                  spacing={2}
                >
                  {(Type == "Approve" || Type == "Issue") && (
                    <Grid item xs={4}>
                      <Typography variant="h6">
                        {" "}
                        <span>Approved Fuel</span>
                      </Typography>
                    </Grid>
                  )}
                  <Grid item xs={7}>
                    {Type == "Approve" || Type == "Issue" ? (
                      <TextField
                        value={
                          selectedRow.approvedFuelQuantity
                            ? selectedRow.approvedFuelQuantity
                            : approvedFuel
                        }
                        variant="outlined"
                        placeholder="Approved Fuel"
                        onChange={(e) => setApprovedFuel(e.target.value)}
                        margin="dense"
                      />
                    ) : (
                      ""
                    )}
                  </Grid>
                  {Type == "Issue" && (
                    <Grid
                      item
                      xs={12}
                      container
                      direction="row"
                      alignItems="center"
                      spacing={2}
                    >
                      <Grid item xs={4}>
                        <Typography variant="h6">
                          {" "}
                          <span>Issue Fuel</span>
                        </Typography>
                      </Grid>
                      <Grid item xs={7}>
                        <TextField
                          type="number"
                          value={issuedFuel}
                          variant="outlined"
                          placeholder="Issue Fuel"
                          onChange={(e) => setIssuedFuel(e.target.value)}
                          margin="dense"
                        />
                      </Grid>
                    </Grid>
                  )}

                  <Grid
                    item
                    xs={12}
                    container
                    direction="row"
                    alignItems="center"
                    spacing={2}
                  >
                    <Grid item xs={4}>
                      <Typography variant="h6">
                        {" "}
                        <span>Remark</span>
                      </Typography>
                    </Grid>
                    <Grid item xs={8}>
                      <TextareaAutosize
                        //maxRows={4}
                        value={Remarkvalue}
                        rowsMin={5}
                        maxLength={50}
                        onChange={(e) => setRemarkValue(e.target.value)}
                        style={{
                          marginTop: "-8px",
                          marginLeft: ".3rem",
                          width: "91%",
                          height: "50px",
                          borderRadius: ".3rem",
                        }}
                        aria-label="maximum height"
                        placeholder="Enter Your Remark"
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            )}
          </DialogContentText>
          <DialogContentText style={{ width: "500px" }}>
            {Type == "Reject" && (
              <Grid
                item
                xs={12}
                container
                direction="row"
                alignItems="center"
                spacing={2}
              >
                <h5
                  style={{
                    fontWeight: "600",
                    marginBottom: "40px",
                    color: "black",
                  }}
                >
                  Are you sure want to reject this Diesel request{" "}
                </h5>
                <Grid item xs={4}>
                  <Typography variant="h6">
                    {" "}
                    <span>Remark</span>
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <TextareaAutosize
                    //maxRows={4}
                    value={Remarkvalue}
                    rowsMin={5}
                    maxLength={50}
                    onChange={(e) => setRemarkValue(e.target.value)}
                    style={{
                      marginTop: "-8px",
                      marginLeft: ".3rem",
                      width: "91%",
                      height: "50px",
                      borderRadius: ".3rem",
                    }}
                    aria-label="maximum height"
                    placeholder="Enter Your Remark"
                  />
                </Grid>
              </Grid>
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {/* <Button onClick={handleAlertClose} color="primary" variant="outlined">
            {Type == "createRequeste"
              ? "Cancle Request "
              : Type == "Reject"
              ? "Cancle Rejected"
              : Type == "Approve"
              ? "Reject"
              : Type == "Issue"
              ? "Cancle"
              :Type == "createIssue"?"Cnacle":""}
          </Button> */}

          <Button onClick={handleAlertClose} color="primary" variant="outlined">
            Cancel
          </Button>
          <Button
            onClick={() => onConfirmHandler(Type)}
            color="primary"
            variant="contained"
          >
            {Type == "createRequeste"
              ? "Submit "
              : Type == "Reject"
              ? " Rejected"
              : Type == "Approve"
              ? "Approve"
              : Type == "Issue"
              ? "Submit"
              : Type == "createIssue"
              ? "Submit"
              : Type == "sync"
              ? "Sync"
              : ""}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
